import { API_DEV } from "constants/api";
import { NOTE_TYPE_SSE } from "constants/dbValues";

import { header, handleAPIResult, serialize, formatMaterialFilters } from "utils";

export const noteService = {
  list,
  listNoSSE,
  get,
  create,
  update,
  powerBiUrl,
};

function list(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/notes?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function listNoSSE(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/notes?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        if ("data" in result) result.data = result.data.filter((n) => n.type_id !== NOTE_TYPE_SSE);
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function get(id) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/notes/" + id, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function create(note) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      note: note,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/notes", postInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function update(note) {
  const patchInfo = {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      note: note,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/notes/" + note.id, patchInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Retourne l'url pour power bi
function powerBiUrl() {
  return API_DEV + "/notes";
}
